<template>
  <section class="section pb-0" v-if="current_enterprise">
    <div class="title is-4 is-pulled-right">
      {{ $t("current enterprise") }}
      <span class="has-text-primary">{{ current_enterprise.name }}</span>
      <span class="has-text-warning" v-if="current_period">
        ({{ current_period.name }})</span
      >
    </div>
  </section>
  <section class="section container">
    <accounts-datatable :current_period="current_period" />
  </section>
</template>

<script>
import { warning_message, error_message, get } from "@/utils";
import AccountsDatatable from "./accounts_datatable/Index.vue";

export default {
  name: "AccountingAccounts",
  components: { AccountsDatatable },
  data() {
    return {
      is_loading: false,
      current_enterprise: undefined,
      current_period: undefined,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    manage_entities() {
      this.$refs.entity_manager_modal.show_modal();
    },
    set_enterprise(enterprise) {
      this.current_enterprise = enterprise;
      /**
       * TODO
       * load selected enterprise information
       */
    },
  },
  mounted() {
    let v = this;
    let period_uuid = v.$route.params.period_uuid;
    if (period_uuid) {
      get("/accounting/period", { uuid: period_uuid })
        .then((period) => {
          if (period) {
            v.current_period = period;
            v.current_enterprise = period.accounting_enterprise;
          }
        })
        .catch((error) => {
          error_message(error);
        });
    }
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
